import { render } from "./Sessions.vue?vue&type=template&id=25b57ff3&scoped=true"
import script from "./Sessions.vue?vue&type=script&lang=js"
export * from "./Sessions.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-25b57ff3"

export default script